<template>
  <div>
    <vue-confirm-dialog></vue-confirm-dialog>
    <div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" id="tasks-photos_Modal" style="min-height: 22rem;">
      <div class="modal-dialog" style="max-width: 78rem">
        <div class="modal-content" id="photoModal">
          <div class="modal-body pb-0" id="simple_photo_checkbox">
            <div class="row">
              <div class="col-md-3">
                <!--              filter side bar -->
                <SideNav/>
              </div>
              <div class="col-sm-9 pl-0">
                <p class="w-100 mb-2 text-dark" style="font-size: 1.45rem">
                  {{ $t('add_photos') }}
                  <span class="float-right" @click="closeModal()" style="cursor: pointer; margin-top: -5px">
                    <i class="fa fa-times"></i>
                  </span>
                </p>
                <div class="row row-cols-5 pr-3 screen-height" id="simple_photo">
                  <div class="col pr-0 pl-2" v-for="(photo,index) in photos" :key="index">
                    <div class="simple-photo" :class="{'modal-images-popup': (index % 5) === 0 }">
                      <PhotoInfoPopup :photo="photo" :isConstruction="false" />
                      <input
                        type="checkbox"
                        class="border d-none border-danger"
                        v-model="tempImages" @change="getImagePlan($event , photo)"
                        :id="'img'+index"
                        :value="{
                          pdphotoid: photo.pdphotoid,
                          src: photo.src,
                          pdphototext: photo.description,
                          description: photo.description,
                          pduserid: photo.pduserid,
                          runid: photo.runid,
                          photodate: photo.photodate,
                          params: photo.params,
                          origname: photo.origname
                      }"
                      />
                      <label :for="'img'+index">
                        <div  data-aspect-ratio="4:3" class="img-fluid">
                          <div :style="{'background-image': 'url(\'' + photo.src + '\')'}"></div>
                        </div>
                      </label>
                      <div class="simple-photo-option">
                        <ul>
                          <li>Nr . {{photo.runid}}</li>
                          <li>|</li>
                          <li>{{photo.photodate | date}}  </li>
                          <li> | </li>
                          <li>{{photo.photodateBytime}}Uhr</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 pt-1 border-top pb-2">
                  <sliding-pagination
                    :current="$store.state.photo.page"
                    :total="$store.state.photo.TPage"
                    @page-change="pageChangeHandler"
                    :classMap='{
                   "componentClass": "pagination-bottom border-top",
                   "list": "pagination justify-content-center pagination-sm",
                   "element": "page-item ",
                   "elementDisabled": "disabled",
                   "elementActive": "active",
                   "page": "page-link" }'/>
                  <div class="float-right p-1" style="margin-top: -30px">
                    <button type="button" @click="closeModal" class="btn btn-danger font13 font-weight-normal" style="padding: 4px 15px;line-height: inherit">
                      Abbrechen
                    </button>
                    <button type="button" @click="setImages" class="btn btn-success font13 font-weight-normal" style="padding: 4px 15px;line-height: inherit">
                      Hinzufügen
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SideNav from '../photo/components/SideNav'
import SlidingPagination from 'vue-sliding-pagination'
import {formatDate} from '../common'
import axios from '../../utils/axiosinstance'
// import axios from 'axios'
import PhotoInfoPopup from '../constructionDiary/components/SideBar/PhotoInfoPopup'
import {mapState} from 'vuex'
export default {
  components: {SideNav, SlidingPagination , PhotoInfoPopup},
  computed: {
    checkedPhotos: {
      get(){
        return this.$store.state.tasks.taskEditPhotos
      },
      set(val){
        this.$store.commit('setTaskEditPhotos', val)
      }
    },
    tempImages: {
      get(){
        return this.$store.state.tasks.taskTempPhotos
      },set(val){
        this.$store.commit('setTaskTempPhotos', val)
      }
    },



    ...mapState({
      photos : state => state.photo.photos,
      task : state => state.tasks.newTaskDetails,
      pages : state => state.tasks.pages,
      isEdit : state => state.tasks.isEdit
    }),
  },

  filters: {
    date :( val ) => formatDate(val),
  },
  methods: {
    pageChangeHandler (selectedPage) {
      this.$store.state.photo.page = selectedPage
      this.$root.$emit('pageChangeHandler', selectedPage)
    },

    closeModal () {
      let ary = []
      this.checkedPhotos.forEach(item => {
        const photo = JSON.parse(JSON.stringify(item));
        const pic = this.tempImages.find(im => im.pdphotoid == photo.pdphotoid);
        if (pic)
          ary.push(pic)
        else
          ary.push(photo)
      })
      this.tempImages = [...ary]
      $('#tasks-photos_Modal').modal('toggle')
    },


    getImagePlan(event , photo) {
      if (event.target.checked) {
        if (!this.isEdit){
          this.getDetails(photo.pdphotoid);
          if (this.task.flawname === "" || !this.task.flawname){
            this.task.flawname = photo.description
          }
        }
      }
    },


    /** Get Flags Of Photos
     *
     * @param id
     * @returns {Promise<void>}
     */
    async getDetails (id) {
      let _this = this
      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `&token=` + localStorage.sessiontoken,
        {
          "methodName": "getFlagsOfProject",
          "serviceName": "ProjectdocuService",
          "parameters": [ this.$route.params.id, 1000, 0,
            {
              "_explicitType": "com\\projectdocu\\PredicateOperatorAndVO",
              "operands": [
                {
                  "_explicitType": "com\\projectdocu\\PredicateOperandEQVO",
                  "fieldname": "pdphotoid",
                  "fieldvalue": id
                }
              ]
            },
            [
              {
                "_explicitType": "com\\projectdocu\\OrderSettingVO",
                "fieldname": "runid",
                "order": "DESC"
              }
            ]

          ],
        }, {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }
      ).then(res => {
        if (res.data.flags.length){
          let flag = _this.task.pdflawflags.find(item => item.pdplanid == res.data.flags[0].pdplanid);
          if (!flag) {
            _this.addPlanToTask(res.data.flags[0])
          }
        }
      })
    },

    addPlanToTask(plan){
      let planFlag = {
        created: "",
        degree: 0,
        lastupdate: null,
        pdflawflagid: 0,
        pdflawid: 0,
        pdplanid: plan.pdplanid, // plan id is here from selected plan
        pdpositionid: null,
        pdprojectid: this.$route.params.id,
        tiltangle: 0,
        viewx: 100,
        viewy: 0,
        xcoord: plan.xcoord,
        ycoord: plan.ycoord,
        _explicitType: "com\\projectdocu\\PDFlawFlagVO"
      }

      let _this = this
      this.$confirm({
        message: "Möchten Sie die Planverortung vom Foto auch für den Mangel verwenden ?",
        button: {
          no: 'Abbrechen',
          yes: 'Ja'
        }, callback: confirm => {
          if (confirm) {
            _this.task.pdflawflags.push(planFlag)
            _this.pages.push(planFlag)
          }
        }
      });
    },

    setImages(){
      let ary = []
      this.tempImages.forEach(item => {
        const photo = JSON.parse(JSON.stringify(item));
        const img  = this.checkedPhotos.find(im => im.pdphotoid == photo.pdphotoid);
        if (img)
          ary.push(img)
        else
          ary.push(photo)
      });
      this.checkedPhotos = [...ary]
      $('#tasks-photos_Modal').modal('toggle')
    }

  }
}
</script>

<!--
/*#mySidenav{
  width: 90% !important;
  margin-left: 5px !important;
  position: initial;
}*/
-->

<style scoped>

.sidenav {
  height: calc(100vh - 60px);
  left: 0;
}
.componentClass{
  width: fit-content;
}
</style>



// WEBPACK FOOTER //
// src/components/tasks/PhotosModal.vue